// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"cc27ad0c","661":"79c42ff2","787":"b28784f4"}[chunkId] + ".chunk.js";
};